export default function Loading() {
  return (
    <div>
      <div className="w-full mx-auto pt-10 pb-10 pl-6 pr-6">
        <div className="animate-pulse space-x-4">
          <div className="bg-gray h-68 w-full rounded" />
          <div className="flex-1 space-y-4 pt-1 pb-1 mt-6">
            <div className="bg-gray h-6 rounded" />
            <div className="bg-gray h-6 rounded w-3/4" />
          </div>
        </div>
      </div>
    </div>
  )
}
